import { showToast } from "@bp/ui-components";
import { t } from "i18next";
import { CombinedError } from "urql";

const autoClose = 2000;

export function showSuccessSaveToast(names?: string[]) {
  showToast(
    t("common.successSaveToastText", {
      count: names ? names.length : 0,
      names: names ? names.join(", ") : "",
    }),
    {
      autoClose,
      type: "success",
    },
  );
}

export function showSuccessCreateToast(names?: string[]) {
  showToast(
    t("common.successCreateToastText", {
      count: names ? names.length : 0,
      names: names ? names.join(", ") : "",
    }),
    {
      autoClose,
      type: "success",
    },
  );
}

export function showSuccessDeleteToast(names?: string[]) {
  showToast(
    t("common.successDeleteToastText", {
      count: names ? names.length : 0,
      names: names ? names.join(", ") : "",
    }),
    {
      autoClose,
      type: "success",
    },
  );
}

export function showSuccessUpdateToast(names?: string[]) {
  showToast(
    t("common.successUpdateToastText", {
      count: names ? names.length : 0,
      names: names ? names.join(", ") : "",
    }),
    {
      autoClose,
      type: "success",
    },
  );
}

export function showSuccessDuplicateToast(names?: string[]) {
  showToast(
    t("common.successDuplicateToastText", {
      count: names ? names.length : 0,
      names: names ? names.join(", ") : "",
    }),
    {
      autoClose,
      type: "success",
    },
  );
}

export function showSuccessToast(message?: string) {
  const text = message ?? t("common.successToastText");
  showToast(text, {
    autoClose,
    type: "success",
  });
}

/** Neutral notice — e.g. a feature that is deliberately not wired up yet. */
export function showInfoToast(message: string) {
  showToast(message, {
    autoClose: 6000,
    type: "info",
  });
}

export function showUserErrorToast({ text, error }: { text?: string; error: unknown }) {
  const _text = text ?? t("common.errorToastText");
  showToast(_text, {
    autoClose,
    type: "error",
  });
}

export function showUserDbErrorToast() {
  showToast(t("common.dbErrorToastText"), {
    autoClose,
    type: "error",
  });
}

export function showErrorToast(error: CombinedError) {
  showToast(`Error - ${error.message}`, {
    type: "error",
  });
}

export function showInviteEmailSendSuccessToast(email: string) {
  showToast(t("users.inviteEmailSendSuccessToastText", { email }), {
    autoClose,
    type: "success",
  });
}
